import { render, staticRenderFns } from "./ChangesModal.vue?vue&type=template&id=a378b0ba&"
import script from "./ChangesModal.vue?vue&type=script&lang=js&"
export * from "./ChangesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports